<template>
  <div class="w-full flex flex-col gap-4 bg-background rounded-lg">
    <h2 class="font-bold">{{ $t("Change password") }}</h2>
    <form class="px-3 py-2" @submit.prevent="submitPasswordChange()">
      <div class="w-full mb-4">
        <Input
          :label="$t('Type your current password')"
          name="currentPassword"
          class="lg:w-3/4 w-full"
          type="password" />
      </div>
      <div class="w-full mb-4">
        <Input name="newPassword" :label="$t('Type your new password')" class="lg:w-3/4 w-full" type="password" />
      </div>
      <div class="w-full mb-4">
        <Input
          name="newPasswordConfirm"
          :label="$t('Retype your new password')"
          class="lg:w-3/4 w-full"
          type="password" />
      </div>
      <Button type="submit"> {{ $t("Change password") }} </Button>
    </form>
  </div>
</template>
<script setup lang="ts">
import { useUserStore } from "@/store/user";
import { useToast } from "@xs2event/js-lib/toast";
import { useI18n } from "vue-i18n";
import { Input, Button } from "@xs2event/js-lib/components";
import { createChangePasswordSchema, type InferType, useForm } from "@xs2event/js-lib/validation";

const userStore = useUserStore();

const emit = defineEmits(["hideModal", "hide"]);

const { t } = useI18n();
const { addToast } = useToast();
const schema = createChangePasswordSchema();

const form = useForm<InferType<typeof schema>>({
  validationSchema: schema,
});

const submitPasswordChange = form.handleSubmit(async (values) => {
  console.log(values);
  const payload = {
    client_id: userStore.client_id,
    new_password: values.newPasswordConfirm,
    origin: "portal",
  };
  userStore
    .updatePassword(payload)
    .then(() => {
      addToast({
        content: t("Password changed successfully"),
        status: "success",
        duration: 5000,
      });
      form.resetForm();
      emit("hide");
    })
    .catch(() => {
      addToast({
        content: t("Something went wrong"),
        status: "error",
        duration: 5000,
      });
    });
});
</script>
